if($('header#header').length){
    $('.navigation-buttons').append($('.top-navigation-tools a[data-target="login"]').clone())
    $('.navigation-buttons').append($('.top-navigation-tools a.top-nav-button-account').clone())
    //$('.login-widget').prepend($('footer#footer .registrace-box').clone())
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');
    $('html').on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    })
}